__turbopack_context__.v({
  "fade-in": "FaqHero-module-scss-module__Z8XYEW__fade-in",
  "no-transform": "FaqHero-module-scss-module__Z8XYEW__no-transform",
  "rotate": "FaqHero-module-scss-module__Z8XYEW__rotate",
  "wrapper": "FaqHero-module-scss-module__Z8XYEW__wrapper",
});
